/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { MEDIA_QUERIES } from 'styles/constants';
import AddonCard from 'screens/manager/Landing/AddonCard';
import PlanCard from 'screens/manager/Landing/PlanCard';
import {
  ADDONS,
  PLANS,
} from 'screens/manager/Landing/plans.constants';

const styles = css`
  background-color: #e8e2ff;
  padding: 110px 57px;

  ${MEDIA_QUERIES.tablet} {
    padding: 70px 32px;
  }

  ${MEDIA_QUERIES.mobile} {
    padding: 50px 20px;
  }

  .plans-header {
    text-align: center;
    margin-bottom: 100px;

    .plans-title {
      color: #313033;
      font-family: Roobert, sans-serif;
      font-size: 68px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin: 0 0 14px;

      em {
        color: #5956f2;
        font-family: Roobert, sans-serif;
        font-size: 68px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      ${MEDIA_QUERIES.tablet} {
        font-size: 48px;
        em {
          font-size: 48px;
        }
      }

      ${MEDIA_QUERIES.mobile} {
        font-size: 36px;
        em {
          font-size: 36px;
        }
      }
    }

    .plans-subtitle {
      color: #313033;
      text-align: center;
      leading-trim: both;
      text-edge: cap;
      font-family: Roobert, sans-serif;
      font-size: 30px;
      font-style: normal;
      font-weight: 400;
      line-height: 145%;
      max-width: 820px;
      margin: 30px auto 0;

      ${MEDIA_QUERIES.tablet} {
        font-size: 22px;
      }

      ${MEDIA_QUERIES.mobile} {
        font-size: 18px;
      }
    }

    ${MEDIA_QUERIES.tablet} {
      margin-bottom: 60px;
    }

    ${MEDIA_QUERIES.mobile} {
      margin-bottom: 40px;
    }
  }

  .plans-grid {
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 20px;
    max-width: 1220px;
    margin: 0 auto 72px;
    padding-top: 20px;

    ${MEDIA_QUERIES.smallScreen} {
      flex-direction: column;
      align-items: center;
      gap: 48px;
    }

    ${MEDIA_QUERIES.tablet} {
      flex-direction: column;
      align-items: center;
      gap: 48px;
    }

    ${MEDIA_QUERIES.mobile} {
      flex-direction: column;
      align-items: center;
      gap: 40px;
    }
  }

  .addons-header {
    text-align: center;
    margin-bottom: 28px;

    .addons-title {
      color: #5e48ff;
      leading-trim: both;
      text-edge: cap;
      font-family: Roobert, sans-serif;
      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      margin: 0 0 8px;

      ${MEDIA_QUERIES.mobile} {
        font-size: 32px;
      }
    }

    .addons-subtitle {
      color: #313033;
      text-align: center;
      leading-trim: both;
      text-edge: cap;
      font-family: Roobert, sans-serif;
      font-size: 30px;
      font-style: normal;
      font-weight: 400;
      line-height: 145%;
      max-width: 1100px;
      margin: 0 auto;

      ${MEDIA_QUERIES.mobile} {
        font-size: 18px;
      }
    }
  }

  .addons-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0;
    max-width: 1200px;
    margin: 0 auto;

    ${MEDIA_QUERIES.tablet} {
      max-width: 810px;
    }

    ${MEDIA_QUERIES.mobile} {
      max-width: 100%;
    }
  }
`;

function Plans() {
  return (
    <section css={styles}>
      <div className="plans-header">
        <h2 className="plans-title">
          Elige el plan <em>perfecto</em>
          <br />
          para tu negocio
        </h2>
        <p className="plans-subtitle">
          Dos planes diseñados para adaptarse al tamaño y objetivo de
          tu negocio, más add-ons para potenciar resultados
        </p>
      </div>

      <div className="plans-grid">
        {PLANS.map((plan) => (
          <PlanCard key={plan.name} {...plan} />
        ))}
      </div>

      <div className="addons-header">
        <p className="addons-title">Add-ons disponibles</p>
        <p className="addons-subtitle">
          Combina cualquier plan con estos servicios adicionales para
          maximizar tu alcance.
        </p>
      </div>

      <div className="addons-grid">
        {ADDONS.map((addon) => (
          <AddonCard key={addon.name} {...addon} />
        ))}
      </div>
    </section>
  );
}

export default Plans;
